import type { IAccessPolicyPermissionsAction } from 'interfaces/IAccessPolicies';

export function checkPermission(permissions: IAccessPolicyPermissionsAction, action: string): boolean;
export function checkPermission(permissions: IAccessPolicyPermissionsAction, actions: string[]): boolean;
export function checkPermission(permissions: IAccessPolicyPermissionsAction, actions: string | string[]): boolean;
export function checkPermission(permissions: IAccessPolicyPermissionsAction, actions: string | string[]): boolean {
  if (typeof actions === 'string') {
    actions = [actions];
  }

  if (!permissions) {
    return false;
  }

  if (permissions.owned) {
    return true;
  }

  if (!Array.isArray(actions)) {
    return false;
  }

  return actions?.some(action => permissions?.actions?.includes(action));
}
